import { http } from '@/services/api';

export interface DashboardSummary {
  totalContacts: number;
  activeContacts: number;
  baptisms: number;
  scheduledVisits: number;
  completedVisitsThisMonth: number;
  activeTeams: number;
  activeUsers: number;
  unreadNotifications: number;
}

export interface RecentActivityItem {
  id: number;
  type: string;
  created_at?: string;
  user?: { id: number; name: string } | null;
  contact?: { id: number; name: string } | null;
  description?: string | null;
}

export interface MyTeamSnapshot {
  active_team: { id: number; name: string } | null;
  members_count: number;
  upcoming_interactions: Array<{
    id: number;
    scheduled_date: string;
    scheduled_time?: string | null;
    contact?: { id: number; name: string } | null;
  }>;
}

export const dashboardService = {
  async summary(): Promise<DashboardSummary> {
    return http.get<DashboardSummary>('/dashboard/summary');
  },
  async recentActivities(): Promise<RecentActivityItem[]> {
    return http.get<RecentActivityItem[]>('/dashboard/recent-activities');
  },
  async myTeam(): Promise<MyTeamSnapshot> {
    return http.get<MyTeamSnapshot>('/dashboard/my-team');
  },
  async pulse(params: { regionId?: number; perPage?: number; include?: string; heartbeat?: boolean }): Promise<{
    unread?: { count: number };
    notifications?: { data: any[]; next_page_url?: string };
    offers?: { data: any[]; next_page_url?: string };
    presence?: { online_count: number; heartbeat_ok: boolean };
  }> {
    const qs = new URLSearchParams();
    if (params.regionId) qs.set('region_id', String(params.regionId));
    if (params.perPage) qs.set('per_page', String(params.perPage));
    if (params.include) qs.set('include', params.include);
    if (params.heartbeat) qs.set('heartbeat', '1');
    return http.get(`/dashboard/pulse?${qs.toString()}`);
  },
};
